import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.modals.data.phone_confirmation,
    props.user.user,
    (phone_confirmation, user) => {
        return {
            stage: phone_confirmation.stage,
            data: phone_confirmation[phone_confirmation.stage],
            user
        }
    }
)